import { Component, OnInit, OnDestroy, Input, ElementRef } from '@angular/core';
import { File } from './../../../models/files/files.model';
import { Subscription } from 'rxjs';
import { PaginationParams } from './../../../models/shared/paginationParams.model';
import { CommunicationService } from './../../../shared/services/communication.service';
import { FilesService } from './../../../shared/services/files.service';

import * as appConfig from '../../../app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from './../../../shared/services/api.service';

@Component({
  selector: 'swb-file-browse',
  templateUrl: './file-browse.component.html',
  styleUrls: ['./file-browse.component.scss']
})
export class FileBrowseComponent implements OnInit, OnDestroy {
  private _subscription: Subscription;
  private _elementHeight = 0;

  public q = '';
  public downloadUrl = appConfig.apiUrl + 'files/download/';
  public chosen: File[] = [];
  public imgOnly = false;
  public isInitialized = false;

  public routeState: string;

  @Input() isSingle = false;

  @Input() browseConfig: any;

  @Input()
  set query(query: string) {
    if (query) {
      this.q = query;
      this._getPaginationParams(query);
      this.p = 1;
      this._getFiles(query, '/filter/');
    } else {
      this.q = '';
      this._getPaginationParams('');
      this._getFiles(this.q, '');
    }
  }

  @Input()
  origin: string;

  public files: File[];

  public pagination: PaginationParams = {
    pageSize: 0,
    total: 0
  };

  public p = 1;

  constructor(
    private _apiService: ApiService,
    private _communicationService: CommunicationService,
    private _filesService: FilesService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _el: ElementRef
  ) {

    this._activatedRoute.data.subscribe(data => {
      const state = data['state'];
      this.routeState = state;
    });
  }

  ngOnInit() {

    if (this._route.snapshot.data.imgOnly !== undefined) {
      this.imgOnly = this._route.snapshot.data.imgOnly;
    }

    if (this.browseConfig.imgOnly !== undefined) {
      this.imgOnly = this.browseConfig.imgOnly;
    }

    if (this._route.snapshot.data.isSingle !== undefined) {
      this.isSingle = this._route.snapshot.data.isSingle;
    }

    if (this.browseConfig.multiple !== undefined) {
      this.isSingle = !this.browseConfig.multiple;
    }

    window.scrollTo(0, 0);

    this._subscription = this._communicationService.modalExecuted$.subscribe(() => {
      this.isInitialized = false;
      this._getPaginationParams('');
      this._getFiles(this.q, '');
    });

    this._getPaginationParams('');
    this._getFiles(this.q, '');
  }

  public pageChanged(p): void {
    this.p = p;
    let uri = '';
    if (this.q.length > 0) {
      uri = '/filter/';
    }
    this._getFiles(this.q, uri);
  }

  public getBoxStyle(isImage: boolean, isResizable: boolean, file: string): any {

    if (isImage) {
      if (isResizable) {
        return {
          'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + '460x460_' + file + ')'
        };
      }
      return {
        'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + file + ')'
      };
    }

    return {};
  }

  // TODO: imgOnly filter!
  public reloadList($event): void {
    let uri = '';
    if (this.q.length > 0) {
      uri = '/filter/';
    }
    this._getFiles(this.q, uri);
    this._getPaginationParams(this.q);
  }

  private _getFiles(query: string, uri: string) {
    this._apiService.get('files' + uri + query + '?page=' + this.p + '&imgOnly=' + this.imgOnly)
      .subscribe(
        (response: any) => {
          this.files = { ...response }.data;
          this.isInitialized = true;
          setTimeout(() => {
            this._elementHeight = this._el.nativeElement.querySelector('.file-browse__wrap').offsetHeight
              + this._el.nativeElement.querySelector('.file-browse__header').offsetHeight;
            this.browseConfig.height = this._elementHeight;
            this._filesService.toggleBrowser(this.browseConfig);
          }, 100);

        },
        (error) => console.error(error)
      );
  }

  public chooseFile(file: File) {
    if (this.isSingle) {
      if (this.chosen.includes(file)) {
        this.chosen = [];
      } else {
        this.chosen = [file];
      }
    } else {
      if (this.chosen.includes(file)) {
        const index = this.chosen.indexOf(file);
        this.chosen.splice(index, 1);
      } else {
        this.chosen.push(file);
      }
    }
  }

  public submitFiles() {
    switch (this.origin) {
      case 'mce':
        if (top['tinymce']) {
          const manager = top['tinymce'].activeEditor.windowManager;
          if (this.chosen[0]) {
            manager.getParams().oninsert(appConfig.apiUrl + appConfig.mediaFolder + '1920x1920_' + this.chosen[0].file_fullname);
          }
          manager.close();
        }
        break;
      default:
        this._filesService.setChosenFiles({ files: this.chosen, guid: this.browseConfig.guid });
        this.close();
        break;
    }
  }

  public close() {
    switch (this.origin) {
      case 'mce':
        if (top['tinymce']) {
          top['tinymce'].activeEditor.windowManager.close();
        }
        break;
      default:
        this._elementHeight = 0;
        this._filesService.toggleBrowser({ open: false, height: this._elementHeight });
        this._router.navigate([{ outlets: { browse: null } }], {
          relativeTo: this._route.parent
        });
        break;
    }
  }

  public filter(query: string): void {
    this.query = query;
  }

  private _getPaginationParams(query: string) {
    this._apiService.get('files/pagination/' + query + '?imgOnly=' + this.imgOnly)
      .subscribe(
        (response: any) => {
          this.pagination = { ...response?.data };
        },
        (error) => console.error(error)
      );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._router.navigate([{ outlets: { browse: null } }], {
      relativeTo: this._route.parent
    });
  }
}
